import { render, staticRenderFns } from "./HomeAutoLoginFreeGift.vue?vue&type=template&id=343a36fe&scoped=true"
import script from "./HomeAutoLoginFreeGift.vue?vue&type=script&lang=js"
export * from "./HomeAutoLoginFreeGift.vue?vue&type=script&lang=js"
import style0 from "./HomeAutoLoginFreeGift.vue?vue&type=style&index=0&id=343a36fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a36fe",
  null
  
)

export default component.exports